import {unwrapResult} from '@reduxjs/toolkit';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Col, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {METHOD_KEYS, WEIGHT_LOSS_KEYS} from '~/constants/medical-questionnaires';
import {useRequestState} from '~/hooks';
import {setQuestionnaireAnswer, setUserQuestionnaireId} from '~/redux/questionnaires/slice';
import {addQuestionnaire} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {getCurrentUserFromStorage} from '~/services/auth';
import {spacing} from '~/utils/theme/spacing';
import {requestOK} from '~/utils/thunk-api';

const Questionnaire20Screen = () => {
  const dispatch: AppDispatch = useDispatch();
  const {questionnaires, wpAuthUser} = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaire = questionnaires?.find(i => i.key === WEIGHT_LOSS_KEYS.DOCTOR_ASSESSMENT);
  const packageQuestionnaire = questionnaires?.find(i => i.key === WEIGHT_LOSS_KEYS.YOUR_TEST_PACKAGE);
  const aptPreferencesQuestionnaire = questionnaires?.find(i => i.key === WEIGHT_LOSS_KEYS.APPOINTMENT_PREFERENCES);
  const medicalQuestionnaireAnswer = useSelector((state: RootState) => state.questionnaires?.collectData);
  const {weight, height} = useSelector(
    (state: RootState) => state.questionnaires?.collectData[WEIGHT_LOSS_KEYS.BMI_CALCULATOR]?.data,
  );
  const currentUser = useSelector(
    (state: RootState) => state.questionnaires?.collectData[WEIGHT_LOSS_KEYS.PROFILE]?.data?.user,
  );
  const history = useHistory();
  const {accessToken: savedToken} = getCurrentUserFromStorage();
  const {loading} = useRequestState(addQuestionnaire);

  const onClickSubmit = async () => {
    const questionnairePackageAnswer = {
      key: WEIGHT_LOSS_KEYS.YOUR_TEST_PACKAGE,
      index: packageQuestionnaire?.index || '',
      data: {},
    };
    const questionnaireAppointmentPreferencesAnswer = {
      key: WEIGHT_LOSS_KEYS.APPOINTMENT_PREFERENCES,
      index: aptPreferencesQuestionnaire?.index || '',
      data: {},
    };

    const resAction = await dispatch(
      addQuestionnaire({
        data: {
          data: {
            ...medicalQuestionnaireAnswer,
            [WEIGHT_LOSS_KEYS.PROFILE]: {data: {user: {...currentUser, height, weight}}},
            [WEIGHT_LOSS_KEYS.YOUR_TEST_PACKAGE]: {...questionnairePackageAnswer},
            [WEIGHT_LOSS_KEYS.APPOINTMENT_PREFERENCES]: {...questionnaireAppointmentPreferencesAnswer},
          },
          wpUserId: wpAuthUser?.wpUserId,
          methodKey: METHOD_KEYS.WEIGHT_LOSS_PROGRAM,
        },
      }),
    );
    if (requestOK(resAction, addQuestionnaire)) {
      const result = unwrapResult(resAction);
      if (result?.booking) {
        const type = result?.slotTime;
        dispatch(setUserQuestionnaireId({id: result?.medical?.id}));
        history.push(`/appointment?type=${type}&methodKey=${METHOD_KEYS.WEIGHT_LOSS_PROGRAM}&token=${savedToken}`);
      }
    }
  };

  return (
    <UiQuestionnaireLayout
      handleOnNext={onClickSubmit}
      checkoutStep={questionnaire?.checkoutStep}
      actions={questionnaire?.actions}
      loading={loading}
    >
      <Col alignItems="center" textAlign="center">
        <UiText fontSize="2xl" fontWeight="bold" mt={spacing.xmedium}>
          {questionnaire?.questions?.default}
        </UiText>
        {questionnaire?.descriptions?.default?.map(text => (
          <UiText key={text} color="blackSecondary" fontSize="sm" mt={spacing.xmedium} px={spacing.medium}>
            {text}
          </UiText>
        ))}
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire20Screen;
